"use client";

import { useState, useEffect } from "react";
import { KbvPluginService } from "@/services/kbvPluginService";

export default function useLichThiDau(leagueId) {
  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!leagueId) {
      setRounds([]);
      return;
    }

    let mounted = true;

    const fetchRounds = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await KbvPluginService.getRoundsByLeagueId(leagueId);

        if (!mounted) return;

        setRounds(data || []);
      } catch (err) {
        console.error(err);
        if (mounted) {
          setError(err);
          setRounds([]);
        }
      } finally {
        mounted && setLoading(false);
      }
    };

    fetchRounds();

    return () => {
      mounted = false;
    };
  }, [leagueId]);

  return {
    rounds,
    loading,
    error,
  };
}
